define('sentient/aba/collections/PrimesCollection',[
	'jquery',
	'underscore',
	'backbone',
	'../models/PrimeModel'
	], function($, _, Backbone, PrimeModel) {
		var PrimesCollection = Backbone.Collection.extend({
			model: PrimeModel,
			initialize: function() {}
		});
		return PrimesCollection;
	});

